import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import mixpanel from 'mixpanel-browser';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})

export class TranslateComponentModalService {
 SAVE_LANGUAGE="/users/save_language"
 API_URL: string = environment.apiBaseUrl
  constructor(private http: HttpClient) { }
  saveTranslateLang(lang): Observable<any> {
    lang = lang == 'none' ? null : lang;
    let input={
      language:lang
    }
    mixpanel.track("User selected language from community/instep question page",{Language: lang})
    const headers = new HttpHeaders();
    headers.set("Authorization", localStorage.getItem("token"));  
    return this.http.post(this.API_URL + this.SAVE_LANGUAGE, input, { headers }).pipe(
      map(response => {
        return response
      })
    )
    
  }
}
